import axios from 'axios'

var host = process.env.VUE_APP_API_HOST

export const eventServices = {
  createEvent,
  updateEvent,
  deleteEvent,
  getEvent,
  isRegisteredForEvent,
  confirmEventRegistration,
  getPaymentSessionEvent,
  refundEventPayment,
  registerForEvent,
  manuallyRegisterForEvent,
  unregisterFromEvent,
  getFirstActivity,
  getActivityDetail,
  getActivityDiscussion,
  getActivityDiscussionForComment,
  getCommentReplies,
  getCommentSummary,
  getActivityComments,
  getEventTemplates,
  getEventSales,
  getEventSalesReport,
  getAllEventTemplates,
  getTemplatesAvailableToSell,
  getEventUserList,
  getUserMentionList,
  downloadActivityReport,
  downloadActivityCompletionReport,
  downloadActivityDiscussionReport,
  downloadExtraMilerDiscussionReport,
  downloadQuestionsReport,
  getBroadcastNotifications,
  deleteBroadcastNotification,
  broadcastNotification,
  getEventUserEnrollmentDetail,
  getEventUsers,
  getEventDays
}

// function getEventUsers () {
//   return [
//     { key: 'Phil', value: 'pheartman' },
//     { key: 'Gordon', value: 'gramsey' },
//     { key: 'Jacob', value: 'jacob' },
//     { key: 'Ethan', value: 'ethan' },
//     { key: 'Emma', value: 'emma' },
//     { key: 'Isabella', value: 'isabella' }
//   ]}
// }

function getEventUsers (id) {
  return axios
    .get(host + '/api/event/' + id + '/users/mention')
    .then(response => {
      // console.log('Event Users: ' + JSON.stringify(response.data))
      var userList = response.data
      var users = []
      for (var i = 0; i < userList.length; i++) {
        users[i] = {
          key: userList[i].name,
          value: userList[i].id
        }
      }
      // console.log('Event Users: ' + JSON.stringify(users))
      return users
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
    })
}

function getEventDays (id) {
  return axios
    .get(host + '/api/event/' + id + '/days')
    .then(response => {
      console.log('Event Days: ' + JSON.stringify(response.data))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
    })
}

function downloadActivityReport (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/activityreport/download')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function downloadActivityCompletionReport (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/activityreport/download/completion')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function downloadExtraMilerDiscussionReport (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/activityreport/download/extramiler')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function downloadActivityDiscussionReport (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/activityreport/download/discussion')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function downloadQuestionsReport (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/activityreport/download/questions')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function createEvent (event) {
  return new Promise(function (resolve, reject) {
    return axios
      .post(host + '/api/event/', event)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function updateEvent (event) {
  return new Promise(function (resolve, reject) {
    return axios
      .put(host + '/api/event/', event)
      .then(response => {
        resolve()
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function deleteEvent (id) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(host + '/api/event/' + id)
      .then(response => {
        resolve()
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function getEvent (id) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + id)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Module Create Error: ' + JSON.stringify(event))
        console.log(err)
        reject(err)
      })
  })
}

function isRegisteredForEvent (eventId, userId) {
  console.log('Attempting isRegisteredForEvent')
  return axios
    .get(host + '/api/registration/event/' + eventId + '/user/' + userId)
    .then(response => {
      console.log('isRegistered: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

// confirm from stripe that the event sale was completed
function confirmEventRegistration (clientId, sessionId) {
  console.log('Attempting confirmEventRegistration')
  return axios
    .get(host + `/api/registration/event/session/${sessionId}/client/${clientId}`)
    .then(response => {
      console.log('isRegistered: ' + JSON.stringify(response))
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getPaymentSessionEvent (eventId, questions, userId) {
  return new Promise(function (resolve, reject) {
    var registration = {
      eventId: eventId,
      userId: userId,
      role: 'User',
      questions: questions
    }
    return axios
      .post(host + '/api/stripe/create-event-payment', registration)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('ERROR: ' + JSON.stringify(err))
        reject(err)
      })
  })
}

function refundEventPayment (paymentIntent) {
  return new Promise(function (resolve, reject) {
    var payment = {
      paymentIntent: paymentIntent
    }
    return axios
      .post(host + '/api/stripe/refund-event-payment', payment)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('ERROR: ' + JSON.stringify(err))
        reject(err)
      })
  })
}

function registerForEvent (eventId, questions, userId) {
  return new Promise(function (resolve, reject) {
    var registration = {
      eventId: eventId,
      userId: userId,
      role: 'User',
      questions: questions
    }
    return axios
      .post(host + '/api/registration/', registration)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        console.log('ERROR: ' + JSON.stringify(err))
        reject(err)
      })
  })
}

function manuallyRegisterForEvent (email, eventId) {
  return new Promise(function (resolve, reject) {
    var registration = {
      eventId: eventId,
      role: 'User',
      email: email
    }
    return axios
      .post(host + '/api/registration/manuallyRegister', registration)
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        // console.log('ERROR: ' + JSON.stringify(err.response))
        reject(err.response)
      })
  })
}

function unregisterFromEvent (eventId, userId) {
  return new Promise(function (resolve, reject) {
    var registration = {
      eventId: eventId,
      userId: userId,
      role: 'User'
    }
    return axios
      .post(host + '/api/registration/remove', registration)
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        console.log('Registration Error: ' + registration)
        console.log(err)
        reject(err)
      })
  })
}

function getFirstActivity (eventId) {
  return axios
    .get(host + '/api/event/' + eventId + '/activity/first')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log(err.response)
      throw err.response
    })
}

// Gets only Active Templates
function getEventTemplates () {
  return axios
    .get(host + '/api/Module')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getEventSales (orderby, direction, pageNumber) {
  return axios
    .get(host + `/api/Event/sales/${orderby}/${pageNumber}?sort=${direction}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getEventSalesReport () {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/sales/report')
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Gets both Active/InActive
function getAllEventTemplates () {
  return axios
    .get(host + '/api/Module/all')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

// Gets Active Templates, that are not copied from another client
function getTemplatesAvailableToSell () {
  return axios
    .get(host + '/api/Module/availabletosell')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getEventUserList (id) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + id + '/users')
      .then(response => {
        // console.log('Event Users: ' + response.data)
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getEventUserEnrollmentDetail (eventid, userid) {
  console.log('Attempting getEventUserEnrollmentDetail')
  console.log(host + `/api/event/${eventid}/user/${userid}/detail`)
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + `/api/event/${eventid}/user/${userid}/detail`)
      .then(response => {
        // console.log('data: ' + JSON.stringify(response.data))
        resolve(response.data)
      })
      .catch(err => {
        console.log('An ERROR has occurred: ', err)
        reject(err)
      })
  })
}

function getUserMentionList (id, startsWith) {
  return new Promise(function (resolve, reject) {
    if (startsWith.length > 2) {
      return axios
        .get(host + '/api/event/' + id + '/users/' + startsWith)
        .then(response => {
          // console.log('Event Users: ' + JSON.stringify(response.data))
          resolve(response.data)
        })
        .catch(err => {
          console.log('An ERROR has occurred: ', err)
          reject(err)
        })
    } else {
      resolve([])
    }
  })
}

function getActivityDetail (eventId, activityId) {
  console.log('Attempting getActivityDetail')
  return axios
    .get(host + '/api/event/' + eventId + '/activity/' + activityId + '/panels')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getActivityDiscussion (eventId, activityId, page) {
  console.log('Event -> getActivityDiscussion(' + eventId + ', ' + activityId + ')')
  return axios
    .get(host + `/api/discussion/event/${eventId}/activity/${activityId}/?page=${page}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getActivityDiscussionForComment (eventId, activityId, commentId) {
  console.log('Event -> getActivityDiscussionForComment(' + eventId + ', ' + activityId + ', ' + commentId + ')')
  var d1 = Date.now()
  return axios
    .get(host + `/api/discussion/event/${eventId}/activity/${activityId}/comment/${commentId}`)
    .then(response => {
      var d2 = Date.now()
      console.log(`========= Took: ${(d2 - d1) / 1000} seconds`)
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getCommentReplies (parentId) {
  console.log(`Event -> GetCommentReplies(${parentId})`)
  return axios
    .get(host + `/api/discussion/${parentId}/replies`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getCommentSummary (parentId) {
  console.log(`Event -> getCommentSummary(${parentId})`)
  return axios
    .get(host + `/api/discussion/${parentId}`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getActivityComments (eventId, activityId) {
  console.log('Event -> getActivityComments(' + eventId + ', ' + activityId + ')')
  return axios
    .get(host + '/api/event/' + eventId + '/activity/' + activityId + '/discussions')
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log('An ERROR has occurred: ', err)
      throw err
    })
}

function getBroadcastNotifications (eventId) {
  return new Promise(function (resolve, reject) {
    return axios
      .get(host + '/api/event/' + eventId + '/notification')
      .then(response => {
        // console.log(JSON.stringify(response.data))
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

function deleteBroadcastNotification (eventId, key) {
  return new Promise(function (resolve, reject) {
    return axios
      .delete(`${host}/api/event/${eventId}/notification/${key}`)
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}

function broadcastNotification (eventId, body, schedule) {
  return new Promise(function (resolve, reject) {
    // var dt = new Date()
    // dt = dt.setMinutes(dt.getMinutes() + 1)
    // console.log(dt)
    var message = {
      body: body,
      scheduleDate: schedule
    }
    return axios
      .post(host + '/api/event/' + eventId + '/notification', message)
      .then(response => {
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}
